export default __webpack_public_path__ + "static/b38b8bd9-d96f-4bf9-add1-adbd2b08b802-a529ce5e5fe787ee686fc01f1f40991b.woff2";